export default "__VITE_ASSET__f754925f__"